import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './../store'


Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    meta: {
      title: "官网 - 葡旅葡萄酒"
    }
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    meta: {
      title: "官网 - 葡旅葡萄酒"
    }
  },
  {
    path: '/winery',
    name: 'Winery',
    component: () => import('../views/Winery.vue'),
    meta: {
      title: "我们的酒庄 - 葡旅葡萄酒"
    }
  },
  {
    path: '/wineryDetails',
    name: 'WineryDetails',
    component: () => import('../views/WineryDetails.vue'),
    meta: {
      title: "酒庄详情 - 葡旅葡萄酒"
    }
  },
  {
    path: '/zoom',
    name: 'Zoom',
    component: () => import('../views/Zoom.vue'),
    meta: {
      title: "葡旅空间 - 葡旅葡萄酒"
    }
  },
  {
    path: '/wine',
    name: 'Wine',
    component: () => import('../views/Wine.vue'),
    meta: {
      title: "美酒 - 葡旅葡萄酒"
    }
  },
  {
    path: '/wineDetails',
    name: 'WineDetails',
    component: () => import('../views/WineDetails.vue'),
    meta: {
      title: "美酒详情 - 葡旅葡萄酒"
    }
  },
  // {
  //   path: '/news',
  //   name: 'News',
  //   component: () => import('../views/News.vue'),
  //   meta: {
  //     title: "新闻动态-葡旅葡萄酒"
  //   }
  // },
  // {
  //   path: '/newsDetails',
  //   name: 'NewsDetails',
  //   component: () => import('../views/NewsDetails.vue'),
  //   meta: {
  //     title: "动态详情-葡旅葡萄酒"
  //   }
  // },
  {
    path: '/life',
    name: 'Life',
    component: () => import('../views/Life.vue'),
    meta: {
      title: "葡旅生活 - 葡旅葡萄酒"
    }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue'),
    meta: {
      title: "联系我们 - 葡旅葡萄酒"
    }
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to,from,next) => {
  let path = to.path,
      index = 0;

  switch(path) {
    case "/":
    case "/home":
      index = 0;
      break;
    case "/wine":
    case "/wineDetails":
      index = 2;
      break;
    case "/zoom":
      index = 3;
      break;
    case "/winery":
    case "/wineryDetails":
      index = 1;
      break;
    case "/life":
      index = 4;
      break;
    case "/contact":
      index = 5;
  }
  if (to.meta.title) {
		document.title = to.meta.title;
	}

  store.state.navIndex = index;
  next();
  
  document.getElementById("app").scrollTo(0, 0);
})

export default router
